module.exports = __webpack_public_path__ + "static/img/i2.09618bb6.svg";